export enum PANELMENUTYPES {
  'FOLDER' = 'FOLDER',
  'AGENDAPAGE' = 'AGENDAPAGE',
  'ANNOUNCEMENT' = 'ANNOUNCEMENT'
}
